import { Container } from '../../Container'

import { component } from './Component.utils'

function Component({ Component, name, ...componentProps }) {
  return (
    <Container label={component(name, componentProps)}>
      <Component {...componentProps} />
    </Container>
  )
}

export default Component
